import { render, staticRenderFns } from "./stage2.vue?vue&type=template&id=561d025a&scoped=true"
import script from "./stage2.vue?vue&type=script&lang=js"
export * from "./stage2.vue?vue&type=script&lang=js"
import style0 from "./stage2.vue?vue&type=style&index=0&id=561d025a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d025a",
  null
  
)

export default component.exports